import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgFeatureFlagsModule } from '@principle-theorem/ng-feature-flags';
import { NgPrincipleSharedModule } from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { TeamCreateDialogComponent } from './team-create-dialog/team-create-dialog.component';
import { TeamEditComponent } from './team-edit/team-edit.component';
import { TeamFormComponent } from './team-form/team-form.component';
import { TeamStafferAssignmentComponent } from './team-staffer-assignment/team-staffer-assignment.component';
import { TeamsListComponent } from './teams-list/teams-list.component';

@NgModule({
  declarations: [
    TeamsListComponent,
    TeamEditComponent,
    TeamFormComponent,
    TeamStafferAssignmentComponent,
    TeamCreateDialogComponent,
  ],
  imports: [
    CommonModule,
    NgSharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgFeatureFlagsModule,
    NgPrincipleSharedModule,
  ],
})
export class TeamsModule {}
